export default __webpack_public_path__ + "static/media/Pfeil_rechts.2602bd20.svg";